/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import {
  ListOrganizationRemoteSessionIssuersResult,
  ListOrganizationRemoteSessionIssuersResult$inboundSchema,
} from "../components/listorganizationremotesessionissuersresult.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListOrganizationRemoteSessionIssuersSecurity = {
  sessionHeaderGramSession?: string | undefined;
  apikeyHeaderGramKey?: string | undefined;
};

/**
 * Only issuers from one tier: organizational (organization), project-specific (project), or from the platform catalog (platform). Omitted lists all three.
 */
export const Tier = {
  Organization: "organization",
  Project: "project",
  Platform: "platform",
} as const;
/**
 * Only issuers from one tier: organizational (organization), project-specific (project), or from the platform catalog (platform). Omitted lists all three.
 */
export type Tier = ClosedEnum<typeof Tier>;

export type ListOrganizationRemoteSessionIssuersRequest = {
  /**
   * Pagination cursor.
   */
  cursor?: string | undefined;
  /**
   * Page size (default 50, max 100).
   */
  limit?: number | undefined;
  /**
   * Only issuers from one tier: organizational (organization), project-specific (project), or from the platform catalog (platform). Omitted lists all three.
   */
  tier?: Tier | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
};

export type ListOrganizationRemoteSessionIssuersResponse = {
  result: ListOrganizationRemoteSessionIssuersResult;
};

/** @internal */
export type ListOrganizationRemoteSessionIssuersSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
  "apikey_header_Gram-Key"?: string | undefined;
};

/** @internal */
export const ListOrganizationRemoteSessionIssuersSecurity$outboundSchema:
  z.ZodMiniType<
    ListOrganizationRemoteSessionIssuersSecurity$Outbound,
    ListOrganizationRemoteSessionIssuersSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
      apikeyHeaderGramKey: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
      });
    }),
  );

export function listOrganizationRemoteSessionIssuersSecurityToJSON(
  listOrganizationRemoteSessionIssuersSecurity:
    ListOrganizationRemoteSessionIssuersSecurity,
): string {
  return JSON.stringify(
    ListOrganizationRemoteSessionIssuersSecurity$outboundSchema.parse(
      listOrganizationRemoteSessionIssuersSecurity,
    ),
  );
}

/** @internal */
export const Tier$outboundSchema: z.ZodMiniEnum<typeof Tier> = z.enum(Tier);

/** @internal */
export type ListOrganizationRemoteSessionIssuersRequest$Outbound = {
  cursor?: string | undefined;
  limit?: number | undefined;
  tier?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
};

/** @internal */
export const ListOrganizationRemoteSessionIssuersRequest$outboundSchema:
  z.ZodMiniType<
    ListOrganizationRemoteSessionIssuersRequest$Outbound,
    ListOrganizationRemoteSessionIssuersRequest
  > = z.pipe(
    z.object({
      cursor: z.optional(z.string()),
      limit: z.optional(z.int()),
      tier: z.optional(Tier$outboundSchema),
      gramSession: z.optional(z.string()),
      gramKey: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        gramKey: "Gram-Key",
      });
    }),
  );

export function listOrganizationRemoteSessionIssuersRequestToJSON(
  listOrganizationRemoteSessionIssuersRequest:
    ListOrganizationRemoteSessionIssuersRequest,
): string {
  return JSON.stringify(
    ListOrganizationRemoteSessionIssuersRequest$outboundSchema.parse(
      listOrganizationRemoteSessionIssuersRequest,
    ),
  );
}

/** @internal */
export const ListOrganizationRemoteSessionIssuersResponse$inboundSchema:
  z.ZodMiniType<ListOrganizationRemoteSessionIssuersResponse, unknown> = z.pipe(
    z.object({
      Result: ListOrganizationRemoteSessionIssuersResult$inboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        "Result": "result",
      });
    }),
  );

export function listOrganizationRemoteSessionIssuersResponseFromJSON(
  jsonString: string,
): SafeParseResult<
  ListOrganizationRemoteSessionIssuersResponse,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      ListOrganizationRemoteSessionIssuersResponse$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'ListOrganizationRemoteSessionIssuersResponse' from JSON`,
  );
}
